<template>
  <TheModalRequest :class="'modal-request-remote-working'">
    <ElementModal @close="closeModal">
      <h2 slot="header">{{ $t(`message.remoteWorking.request.title`) }}</h2>
      <div slot="body">
        <div class="modal-request-remote-working__info" v-if="error.start || error.end || error.location || errorMessage">
          <div v-if="error.start">Invalid or empty start date</div>
          <div v-if="error.end">Invalid or empty end date</div>
          <div v-if="error.location">Invalid or empty location</div>
          <div v-if="errorMessage">{{ errorMessage }}</div>
        </div>

        <form id="remoteWorkingRequest" @submit.prevent="submitForm">
          <!-- Start Date -->
          <ElementFormGroup :label="$t(`message.modal.request.startDate`)">
            <ElementFormDay placeholder="From" selected-value="morning" @change="handleStartDate" />
          </ElementFormGroup>

          <!-- End Date -->
          <ElementFormGroup :label="$t(`message.modal.request.endDate`)">
            <ElementFormDay placeholder="End" selected-value="afternoon" @change="handleEndDate" />
          </ElementFormGroup>

          <!-- Location -->
          <ElementFormGroup :label="$t(`message.modal.request.location`)">
            <ElementFormText @change="handleLocation" />
          </ElementFormGroup>

          <!-- Comment -->
          <ElementFormGroup :label="$t(`message.modal.request.comment`)">
            <ElementFormTextarea @change="handleComment" />
          </ElementFormGroup>

          <!-- Button -->
          <div class="form-group">
            <BaseSubmit :disabled="!allowSubmit">{{ $t(`message.modal.request.submit`) }}</BaseSubmit>
            <span>{{ $t(`message.modal.request.or`) }}</span>
            <a href="javascript:void(0)" class="button-cancel" @click="cancelForm()">{{ $t(`message.modal.request.cancel`) }}</a>
          </div>
        </form>
      </div>
    </ElementModal>
  </TheModalRequest>
</template>

<script>
import { fetchPostService } from '@modules/api'
import { mapGetters, mapActions } from 'vuex'
import BaseSubmit from '@base/BaseSubmit'
import ElementFormGroup from '@elements/ElementFormGroup'
import ElementFormDay from '@elements/ElementFormDay'
import ElementFormText from '@elements/ElementFormText'
import ElementFormTextarea from '@elements/ElementFormTextarea'
import ElementModal from '@elements/ElementModal'
import TheModalRequest from './TheModalRequest'

export default {
  name: 'TheModalRemoteWorkingRequest',
  components: {
    BaseSubmit,
    ElementModal,
    ElementFormGroup,
    ElementFormDay,
    ElementFormText,
    ElementFormTextarea,
    TheModalRequest
  },
  props: {
    submit: {
      type: String,
      required: false
    },
    content: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      allowSubmit: false,
      error: {
        start: false,
        end: false,
        location: false
      },
      start: {
        date: '',
        moment: ''
      },
      end: {
        date: '',
        moment: ''
      },
      location: '',
      comment: '',
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      name: 'modal/getName'
    }),
    showModal () {
      return this.name === 'remote-working'
    }
  },
  watch: {
    start: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    },
    end: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    },
    location: {
      handler () {
        this.checkSubmitAvailability()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      updateName: 'modal/updateName',
      fetchGetPage: 'page/fetchGetPage'
    }),
    closeModal () {
      this.updateName('')
    },
    submitForm () {
      this.error.start = this.start.date === ''
      this.error.end = this.end.date === ''
      this.error.location = this.location === ''

      if (!this.error.start && !this.error.end && !this.error.location) {
        fetchPostService('remote-working-request', {
          start: { ...this.start },
          end: { ...this.end },
          location: this.location,
          comment: this.comment
        })
          .then(({ data }) => {
            this.errorMessage = ''
            if (data.error && !data.success) {
              this.errorMessage = data.error
            } else {
              this.fetchGetPage({ service: 'remote-working' }).then(() => {
                this.closeModal()
              })
            }
          })
      }
    },
    cancelForm () {
      this.updateName('')
    },
    handleStartDate (object) {
      this.start = { ...object }
    },
    handleEndDate (object) {
      this.end = { ...object }
    },
    handleLocation (string) {
      this.location = string
    },
    handleComment (string) {
      this.comment = string
    },
    checkSubmitAvailability () {
      this.allowSubmit = this.start.date !== '' && this.end.date !== '' && this.location !== ''
    }
  }
}
</script>

<style lang="scss">
.modal-request-remote-working{
  &__info{
    @include form-info-error;
  }
}
</style>
